export default __webpack_public_path__ + "static/media/Landing.43253168.jpg";